import React, { useCallback } from 'react';

import { ELASTIC_CONFIG_FIELDS } from '../../common/fields';
import * as actions from '../../containers/Advanced/advancedActions';

import TextInput from '../Controls/TextInput/TextInput';

const ElasticConfig = ({ fields, dispatch }) => {
    const thresholdPercentage = fields[ELASTIC_CONFIG_FIELDS.THRESHOLD_PERCENTAGE.ID];
    const eventThresholdPercentage = fields[ELASTIC_CONFIG_FIELDS.EVENT_THRESHOLD_PERCENTAGE.ID];
    const dcForNotify = fields[ELASTIC_CONFIG_FIELDS.DISCONNECTIONS_FOR_NOTIFY.ID];
    const numOfShards = fields[ELASTIC_CONFIG_FIELDS.NUM_OF_SHARDS.ID];

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_ELASTIC_CONFIG,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {thresholdPercentage && <TextInput field={thresholdPercentage} changed={dispatchUpdate} />}
            {eventThresholdPercentage && <TextInput field={eventThresholdPercentage} changed={dispatchUpdate} />}
            {dcForNotify && <TextInput field={dcForNotify} changed={dispatchUpdate} />}
            {numOfShards && <TextInput field={numOfShards} changed={dispatchUpdate} />}
        </>
    );
};

export default React.memo(ElasticConfig);
